import React from 'react';
import { prescreenType, TOPUP_PLUS_SOURCES, TOPUP_SOURCES as TOPUP_SOURCES_FROM_PSS } from '../pss-entry';
import { ASTRIK, DAGGER, DISCLAIMER_SYMBOL, ONE, THREE, TWO } from './symbols';
import {
  areThereAnyFees,
  amIRequiredToTakeOutExtraAmount,
  amIRequiredToTakeOutAnExtraLoanAmount,
  howMuchCanIBorrow,
  whatHappensAfterICheck,
  whatIsTopUpLoan,
  howCanIUseMyTopUpLoan,
  willCheckingMyRateAffectMyScore,
  howQuicklyCanIGetTopUpLoan,
  whatCouldAffectTheFinalAmountOfCash,
  shouldIContinueMakingPayments,
  howDebtPayoffLoanWork,
  whatTypeOfDebtsQualify,
  doINeedToPayMyDebtInFull,
  whatAreTheRequirementsToGetDiscountedRate,
  willIKeepDiscountedRateForLifeOfTheLoan,
  whenWillLendingClubProcessThePayments,
  whyTheCreditorNameLooksDifferent,
  howWillITrackThePayments,
  willLendingClubCloseMyAccounts,
  whenWillIGetTheRemainingFunds,
  whatIsTopUpLoanPA,
  howCanIUseMyTopUpLoanPA,
  amIRequiredToTakeOutExtraAmountPA,
  howMuchCanIBorrowPA,
  willCheckingMyRateAffectMyScorePA,
  howQuicklyCanIGetTopUpLoanPA,
  whatHappensAfterICheckPA,
  whatCouldAffectTheFinalAmountOfCashPA,
  whatIsTopUpLoanTopupPlus,
  howCanIUseMyTopUpLoanTopupPlus,
  amIRequiredToTakeOutExtraAmountTopupPlus,
  howMuchCanIBorrowTopupPlus,
  willCheckingMyRateAffectMyScoreTopupPlus,
  howQuicklyCanIGetTopUpLoanTopupPlus,
  whatHappensAfterICheckTopupPlus,
  whatCouldAffectTheFinalAmountOfCashTopupPlus,
  howDoDirectPaymentsWork,
  whatAreRequirementsGetDiscountedRate,
  willIKeepDiscountedRateForLifeOfLoan,
  whatIfICantFindMyCreditors,
  whatIsTopUpLoanTopupMB,
  whatIsTopUpLoanTopupPlusMB,
  howCanIUseAPersonalLoan,
  whatIsAPersonalLoan,
  howQuicklyCanIGetMyLoan,
  whatHappensAfterICheckEA_Entry,
  howDoesDirectPayWork,
  whatAreTheRequirementsToGetTheDirectPayDiscount,
  whatTypeOfDebtsQualifyWithDirectPay,
  whyDoesTheCreditorNameLookDifferent,
  whatIfICantFindMyCreditorForDirectPay,
  doINeedToPayMyDebtInFullForDirectPay,
  whenWillLendingClubProcessThePaymentsToMyCreditors,
  howWillITrackThePaymentsToMyCreditors,
  willLendingClubCloseMyAccountsWithMyCreditors,
  whenWillIGetTheRemainingFundsIntoMyBankAccount,
  willIKeepTheDirectPayDiscountForTheLifeOfTheLoan,
} from '../../shared_modules/baui-ui/components/FAQ/questions';

/**
 * @typedef {Object} ContentWithKey - holds a key and content
 * @property {string} key - for use in React loops
 * @property {import('react').ReactElement | string} text - a React element or string
 */

/**
 * Take a content object with a key and prefix it with a superscript value.
 *
 * @param {Object} options - content object with a key and prefix it with a superscript value
 * @param {string | ContentWithKey} options.content - The content to prefix with a superscript
 * @param {number | string} options.sup - The superscript value to add
 * @param {string=} options.key - Optional key override
 *
 * @returns {ContentWithKey} A new content object with the superscript added and a unique key
 */
// TODO: This should be a component that is consumed in the respective page.
//       In other words, the superscript should not be set in this file.
export function addKeyedSuperscript({ content, sup, key: keyOverride }) {
  const { text, key: contentKey } = typeof content === 'object' ? content : { text: content };
  const key = keyOverride ?? contentKey;
  if (!key) {
    throw new TypeError('Invalid key');
  }
  return {
    key: keyOverride ?? `${sup}_${key}`,
    text:
      sup === ASTRIK ? (
        <>
          {sup} {text}
        </>
      ) : (
        <>
          <sup>{sup}</sup> {text}
        </>
      ),
  };
}

export const TOPUP_SOURCES = TOPUP_SOURCES_FROM_PSS;

export const OFFERS = {
  INVESTOR_MESSAGE:
    'Loan offers are not guaranteed and are subject to investor demand. Once you submit a finalized application, we’ll look for an investor. If we cannot find a suitable investor, your request for a loan may be cancelled.',
};

export const TIL = {
  INVESTOR_MESSAGE:
    'Loan issuance is not guaranteed and is subject to investor demand. If we cannot find a suitable investor, your request for a loan may be canceled.',
};

export const REPEATS = {
  SPINNER: {
    default: {
      header: 'One moment',
      text: 'while we help build your loan...',
    },
    promise: {
      title: 'Just a moment...',
      subtitle: 'Processing your application',
      successTitle: 'Your offer is ready!',
    },
    inprogress: {
      title: 'Just a moment...',
      subtitle: 'Setting up CleanSweep™',
    },
    [prescreenType.TOP_UP]: {
      title: 'Just a moment...',
      subtitle: 'Processing your request',
    },
    simple: {
      title: 'Just a moment...',
    },
  },
  PROGRESS_NAV_BAR_TYPES: {
    ONT: 'ont',
    PRE_APPROVED: 'preApproved',
    ILOC: 'iloc',
  },
};

/**
 * @typedef {"EASY_APPLY" | "BT_MANDATORY" | "BTA" | "CASH"} OfferType
 */
/**
 * Offer Flows, include new one only if you are sure it is a new flow even if we reuse pages, we need to be sure we need different
 *
 *
 */
export const OFFER_TYPES = {
  EASY_APPLY: 'EASY_APPLY',
  BT_MANDATORY: 'BT_MANDATORY',
  BTA: 'BTA',
  CASH: 'CASH',
};

export const OFFER_MODALS = {
  BT: {
    PAY_DOWN_AMOUNT: 'PAY_DOWN_AMOUNT',
    BT_HELP: 'BT_HELP',
    BT_MANDATORY: 'BT_MANDATORY',
    SAVINGS_COMPARE_MODAL: 'SAVINGS_COMPARE_MODAL',
    OFFER_CONGRATS: 'BT_OFFER_CONGRATS',
  },
  CASH: {
    PLAID: 'PLAID',
    OFFER_CONGRATS: 'CASH_OFFER_CONGRATS',
    PA_CONGRATS: 'PA_CONGRATS',
  },
  LOAN_CHOICE: 'LOAN_CHOICE',
  LOW_DISCOUNTED_O_FEE: 'DISCOUNTED_O_FEE',
  ZERO_O_FEE: 'ZERO_O_FEE',
  CREDIT_UNION: 'CREDIT_UNION',
  OFFER_DIRECT_PAY: 'OFFER_DIRECT_PAY',
  DEBT_IQ: 'DEBT_IQ',
};

export const OFFER_TOOLTIPS = {
  LOW_DISCOUNTED_O_FEE: 'DISCOUNTED_O_FEE',
};

export const OFFER_TEMPLATES = {
  BT: {
    BTA: 'offers-bta-toggle/template',
  },
  EASY_APPLY: 'offers-bt-easy-apply/template',
  CASH: 'offers-cash-redesign/server/template',
};

export const BT_OFFER_UP_KEYS = {
  OFFER_UP: 'BT_OfferUp',
  OFFER_UP1: 'BT_OfferUp1',
};

export const CASH_OFFER_UP_KEYS = {
  OFFER_UP: 'Cash_OfferUp',
  OFFER_UP1: 'Cash_OfferUp1',
};

export const OFFER_UP_TAGS = {
  BT: [BT_OFFER_UP_KEYS.OFFER_UP, BT_OFFER_UP_KEYS.OFFER_UP1],
  CASH: [CASH_OFFER_UP_KEYS.OFFER_UP, CASH_OFFER_UP_KEYS.OFFER_UP1],
};

export const DISCOUNT_STATUS = {
  QUALIFIED: 'QUALIFIED',
  DISCOUNTED: 'DISCOUNTED',
};

export const DISCOUNT_TYPES = {
  ONT: 'ont',
  PRE_APPROVED: 'preapproved',
};

export const ONT_STATUS = { QUALIFIED: 'QUALIFIED', DISCOUNTED: 'DISCOUNTED' };

export const ONT_KEY = {
  OFEE: {
    DISC: 'ONT_OFEE_DISCOUNTED',
    QUAL: 'ONT_OFEE_QUALIFIED',
    text: 'ofee',
    preFix: 'ofee_',
  },
  COUPON: {
    DISC: 'ONT_COUPON_DISCOUNTED',
    QUAL: 'ONT_COUPON_QUALIFIED',
    text: 'coupon',
  },
};

export const PA_KEY = {
  PRE_APPROVED: {
    QUAL: 'PRE_APPROVED',
    text: 'non-discount',
  },
  COUPON: {
    QUAL: 'PRE_APPROVED_COUPON_QUALIFIED',
    DISC: 'PRE_APPROVED_COUPON_DISCOUNTED',
    preFix: 'coupon_',
  },
  OFEE: {
    QUAL: 'PRE_APPROVED_OFEE_QUALIFIED',
    DISC: 'PRE_APPROVED_OFEE_DISCOUNTED',
  },
};

const ONT_OFEE_DISCOUNTED = ONT_KEY.OFEE.DISC;
const ONT_OFEE_QUALIFIED = ONT_KEY.OFEE.QUAL;
const ONT_COUPON_QUALIFIED = ONT_KEY.COUPON.QUAL;
const ONT_COUPON_DISCOUNTED = ONT_KEY.COUPON.DISC;

// ONT DISCOUNTED KEYS
export const ONT_OFEE_DISC_PAYLOAD_KEY_1 = `${ONT_OFEE_DISCOUNTED}|1`;
export const ONT_OFEE_DISC_PAYLOAD_KEY_2 = `${ONT_OFEE_DISCOUNTED}|2`;
export const ONT_COUPON_DISC_PAYLOAD_KEY_1 = `${ONT_KEY.COUPON.DISC}|1`;

// ONT QUALIFIED KEYS
export const ONT_OFEE_QUAL_PAYLOAD_KEY_1 = `${ONT_OFEE_QUALIFIED}|1`;
export const ONT_OFEE_QUAL_PAYLOAD_KEY_2 = `${ONT_OFEE_QUALIFIED}|2`;
export const ONT_COUPON_QUAL_PAYLOAD_KEY_1 = `${ONT_KEY.COUPON.QUAL}|1`;

export const OFEE = ONT_KEY.OFEE.text;
export const COUPON = ONT_KEY.COUPON.text;
export const PA_V1_NON_DISCOUNT = PA_KEY.PRE_APPROVED.text;

export const PA_OFEE_QUALIFIED_V1 = `${PA_KEY.OFEE.QUAL}|1`;
export const PA_OFEE_DISCOUNTED_V1 = `${PA_KEY.OFEE.DISC}|1`;
export const PA_COUPON_DISCOUNTED_V1 = `${PA_KEY.COUPON.DISC}|1`;
export const PA_COUPON_QUALIFIED_V1 = `${PA_KEY.COUPON.QUAL}|1`;

// BT PAYLOAD KEY
export const BT_DISCOUNT_PAYLOAD_KEY_V1 = 'BT_DISCOUNT|1';

// ** PSS context keys **
export const PA_COUPON_QUALIFIED = 'COUPON_QUALIFIED';
export const PA_OFEE_QUALIFIED = 'PA_OFEE_QUALIFIED';
export const PA_OFEE_DISCOUNTED = 'PA_OFEE_DISCOUNTED';

export const PA_QUAL_LIST = [PA_COUPON_QUALIFIED, PA_OFEE_QUALIFIED];

export const PA_V1_QUALIFIED = `${PA_KEY.PRE_APPROVED.QUAL}|1`; // to identify pre approve v1 type (non-dicount)
// to handle non mapped payload types e.g. when there's no payloadMap from offer item
export const PSS_CONTEXT_PAYLOAD_TYPES_MAP = {
  [PA_COUPON_QUALIFIED]: DISCOUNT_TYPES.PRE_APPROVED,
  [PA_OFEE_QUALIFIED]: DISCOUNT_TYPES.PRE_APPROVED,
};
// **

//this can be changed based on PBS changes
export const ONT_TYPES = {
  [ONT_OFEE_QUALIFIED]: OFEE,
  [ONT_OFEE_DISCOUNTED]: OFEE,
  [ONT_COUPON_QUALIFIED]: COUPON,
  [ONT_COUPON_DISCOUNTED]: COUPON,
  [ONT_OFEE_QUAL_PAYLOAD_KEY_1]: OFEE,
  [ONT_OFEE_DISC_PAYLOAD_KEY_1]: OFEE,
  [ONT_OFEE_QUAL_PAYLOAD_KEY_2]: OFEE,
  [ONT_OFEE_DISC_PAYLOAD_KEY_2]: OFEE,
  [ONT_COUPON_QUAL_PAYLOAD_KEY_1]: COUPON,
  [ONT_COUPON_DISC_PAYLOAD_KEY_1]: COUPON,
};

export const KEY_PREFIX = {
  [ONT_OFEE_QUAL_PAYLOAD_KEY_1]: ONT_KEY.OFEE.preFix,
  [ONT_OFEE_DISC_PAYLOAD_KEY_1]: ONT_KEY.OFEE.preFix,
  [PA_COUPON_QUALIFIED]: PA_KEY.COUPON.preFix,
  [PA_OFEE_DISCOUNTED_V1]: PA_KEY.OFEE.preFix,
};

export const DISC_PCT = 'disc_pct';
export const DISC_LEVEL = 'disc_level';

export const DISC_PCT_KEYS = {
  [ONT_OFEE_QUAL_PAYLOAD_KEY_1]: 'disc_est_pct',
  [ONT_OFEE_DISC_PAYLOAD_KEY_1]: DISC_PCT,
  [ONT_OFEE_QUAL_PAYLOAD_KEY_2]: DISC_PCT,
  [ONT_OFEE_DISC_PAYLOAD_KEY_2]: DISC_PCT,
  [ONT_COUPON_QUAL_PAYLOAD_KEY_1]: DISC_LEVEL,
  [ONT_COUPON_DISC_PAYLOAD_KEY_1]: DISC_LEVEL,
};

export const PAYLOAD_MAP_KEYS = {
  UPFRONT_VS_ZERO_OFEE: 'UPFRONT_VS_ZERO_OFEE',
  PL_TOPUP_OFFER_DETAILS: 'PL_TOPUP_OFFER_DETAILS',
  PL_TOPUP_OFFER: 'PL_TOPUP_OFFER',
};

export const PRE_APPROVED_STATUS = {
  [PA_COUPON_QUALIFIED_V1]: DISCOUNT_STATUS.QUALIFIED,
  [PA_COUPON_DISCOUNTED_V1]: DISCOUNT_STATUS.DISCOUNTED,
  [PA_COUPON_QUALIFIED]: DISCOUNT_TYPES.PRE_APPROVED,
};

export const PAYLOAD_MAP_TYPES = {
  [ONT_OFEE_QUALIFIED]: DISCOUNT_TYPES.ONT,
  [ONT_OFEE_DISCOUNTED]: DISCOUNT_TYPES.ONT,
  [ONT_COUPON_QUALIFIED]: DISCOUNT_TYPES.ONT,
  [ONT_COUPON_DISCOUNTED]: DISCOUNT_TYPES.ONT,
  [ONT_OFEE_QUAL_PAYLOAD_KEY_1]: DISCOUNT_TYPES.ONT,
  [ONT_OFEE_DISC_PAYLOAD_KEY_1]: DISCOUNT_TYPES.ONT,
  [ONT_OFEE_QUAL_PAYLOAD_KEY_2]: DISCOUNT_TYPES.ONT,
  [ONT_OFEE_DISC_PAYLOAD_KEY_2]: DISCOUNT_TYPES.ONT,
  [ONT_COUPON_QUAL_PAYLOAD_KEY_1]: DISCOUNT_TYPES.ONT,
  [ONT_COUPON_DISC_PAYLOAD_KEY_1]: DISCOUNT_TYPES.ONT,
  [PA_COUPON_DISCOUNTED_V1]: DISCOUNT_TYPES.PRE_APPROVED,
  [PA_OFEE_DISCOUNTED_V1]: DISCOUNT_TYPES.PRE_APPROVED,
  [PA_V1_QUALIFIED]: DISCOUNT_TYPES.PRE_APPROVED,
  ...PSS_CONTEXT_PAYLOAD_TYPES_MAP,
};

export const PAYLOAD_MAP_SUBTYPES = {
  ...ONT_TYPES,
  [PA_COUPON_DISCOUNTED_V1]: COUPON,
  [PA_COUPON_QUALIFIED_V1]: COUPON, // PA Coupon Qualified type from offer item payloadMap
  [PA_COUPON_QUALIFIED]: COUPON, // PA Coupon Qualified type from PSS offers payloadType => "COUPON_QUALIFIED"
  [PA_V1_QUALIFIED]: PA_V1_NON_DISCOUNT,
  [PA_OFEE_QUALIFIED_V1]: OFEE,
  [PA_OFEE_DISCOUNTED_V1]: OFEE,
};

export const PAYLOAD_MAP_SUB_TYPES = {
  ...ONT_TYPES,
  [PA_COUPON_DISCOUNTED_V1]: COUPON,
};

export const PRODUCT_NAMES = {
  PAGAYA: 'Pagaya',
};

export const PRODUCT_OFFER_IDS = {
  1031: 'CU',
};

export const NON_CU_INVESTOR_IDS = {
  225173839: 'HFI',
};

export const SPECIAL_LIMITED_CHARACTERS_REGEX = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/;
export const ALPHA_CHARACTERS_REGEX = /^[A-Za-z]+$/;

const DISCOUNT_BULLET_LABELS = {
  BT: 'Balance Transfer Discount',
  INTEREST_RATE: 'Interest Rate Discount',
  OFEE: 'Origination Fee Discount',
  DEBT_PAYOFF: 'Debt Paydown Discount',
};
export const discountedTooltipInfo = {
  control: {
    title: 'Discounted Rate',
    content: 'The green numbers show savings with a Balance Transfer Loan vs a Cash Loan equivalent',
  },
  btRedesign: {
    title: 'Discounted Rate',
    content:
      'The debt paydown loan gives you a discounted rate. In this {{duration}}-month offer, you get a {{apr}} APR on the debt paydown loan compared to a {{aprCash}} APR if you chose the cash loan.',
  },
  singleDiscount: {
    title: 'Discounts Applied',
    content: 'The green numbers show your final rates with all discounts applied',
    discountList: [DISCOUNT_BULLET_LABELS.INTEREST_RATE],
  },
  multipleDiscount: {
    title: 'Multiple Discounts Applied',
    content: 'The green numbers show your final rates with all discounts applied',
    discountList: [DISCOUNT_BULLET_LABELS.BT, DISCOUNT_BULLET_LABELS.INTEREST_RATE],
  },
  OFeeMultiDiscount: {
    title: 'Discounts Applied',
    content: 'The green numbers show your final rates with all discounts applied',
    discountList: [DISCOUNT_BULLET_LABELS.BT, DISCOUNT_BULLET_LABELS.OFEE],
  },
  OFeeSingleDiscount: {
    title: 'Discounts Applied',
    content: 'The green numbers show your final rates with all discounts applied',
    discountList: [DISCOUNT_BULLET_LABELS.OFEE],
  },
};

export const CU_DISCLAIMER = {
  title: {
    text: 'We work with multiple investors to secure competitive rates for our members.',
  },
  subtitle: {
    text: 'A credit union may be selected to invest in your loan.',
  },
};

export const BETTER_RATE_DIFFS = {
  MIN: 0.0005,
  MAX: 0.0025,
};

export const FAQ_CONTENT = {
  TOPUPPLUS: {
    OFFER: [
      { ...areThereAnyFees },
      { ...amIRequiredToTakeOutAnExtraLoanAmount },
      { ...howMuchCanIBorrow },
      { ...whatCouldAffectTheFinalAmountOfCash },
      { ...whatHappensAfterICheck },
      { ...shouldIContinueMakingPayments },
    ],
    BT_WORKSHEET: [
      { ...howDoDirectPaymentsWork },
      { ...whatAreTheRequirementsToGetDiscountedRate },
      { ...willIKeepDiscountedRateForLifeOfTheLoan },
      { ...whatIfICantFindMyCreditors },
    ],
    SUMMARY_PAGE: [
      { ...howDoDirectPaymentsWork },
      { ...whatAreTheRequirementsToGetDiscountedRate },
      { ...willIKeepDiscountedRateForLifeOfTheLoan },
      { ...whatIfICantFindMyCreditors },
    ],
  },
  TOPUP: {
    OFFER: [
      { ...areThereAnyFees },
      { ...amIRequiredToTakeOutExtraAmount },
      { ...howMuchCanIBorrow },
      { ...whatCouldAffectTheFinalAmountOfCash },
      { ...whatHappensAfterICheck },
      { ...shouldIContinueMakingPayments },
    ],
    LANDING: [
      { ...whatIsTopUpLoan },
      { ...howCanIUseMyTopUpLoan },
      { ...areThereAnyFees },
      { ...amIRequiredToTakeOutExtraAmount },
      { ...howMuchCanIBorrow },
      { ...willCheckingMyRateAffectMyScore },
      { ...howQuicklyCanIGetTopUpLoan },
      { ...whatHappensAfterICheck },
      { ...whatCouldAffectTheFinalAmountOfCash },
    ],
    MB_LANDING: [
      { ...whatIsTopUpLoanTopupMB },
      { ...howCanIUseMyTopUpLoan },
      { ...areThereAnyFees },
      { ...amIRequiredToTakeOutExtraAmount },
      { ...howMuchCanIBorrow },
      { ...willCheckingMyRateAffectMyScore },
      { ...howQuicklyCanIGetTopUpLoan },
      { ...whatHappensAfterICheck },
      { ...whatCouldAffectTheFinalAmountOfCash },
    ],
    PA_LANDING: [
      { ...whatIsTopUpLoanPA },
      { ...howCanIUseMyTopUpLoanPA },
      { ...areThereAnyFees },
      { ...amIRequiredToTakeOutExtraAmountPA },
      { ...howMuchCanIBorrowPA },
      { ...willCheckingMyRateAffectMyScorePA },
      { ...howQuicklyCanIGetTopUpLoanPA },
      { ...whatHappensAfterICheckPA },
      { ...whatCouldAffectTheFinalAmountOfCashPA },
    ],
    PA_MB_LANDING: [
      { ...whatIsTopUpLoanTopupMB },
      { ...howCanIUseMyTopUpLoanPA },
      { ...areThereAnyFees },
      { ...amIRequiredToTakeOutExtraAmountPA },
      { ...howMuchCanIBorrowPA },
      { ...willCheckingMyRateAffectMyScorePA },
      { ...howQuicklyCanIGetTopUpLoanPA },
      { ...whatHappensAfterICheckPA },
      { ...whatCouldAffectTheFinalAmountOfCashPA },
    ],
    PLUS_LANDING: [
      { ...whatIsTopUpLoanTopupPlus },
      { ...howCanIUseMyTopUpLoanTopupPlus },
      { ...areThereAnyFees },
      { ...amIRequiredToTakeOutExtraAmountTopupPlus },
      { ...howMuchCanIBorrowTopupPlus },
      { ...willCheckingMyRateAffectMyScoreTopupPlus },
      { ...howQuicklyCanIGetTopUpLoanTopupPlus },
      { ...whatHappensAfterICheckTopupPlus },
      { ...whatCouldAffectTheFinalAmountOfCashTopupPlus },
    ],
    PLUS_MB_LANDING: [
      { ...whatIsTopUpLoanTopupPlusMB },
      { ...howCanIUseMyTopUpLoanTopupPlus },
      { ...areThereAnyFees },
      { ...amIRequiredToTakeOutExtraAmountTopupPlus },
      { ...howMuchCanIBorrowTopupPlus },
      { ...willCheckingMyRateAffectMyScoreTopupPlus },
      { ...howQuicklyCanIGetTopUpLoanTopupPlus },
      { ...whatHappensAfterICheckTopupPlus },
      { ...whatCouldAffectTheFinalAmountOfCashTopupPlus },
    ],
    BT_WORKSHEET: [
      { ...howDoDirectPaymentsWork },
      { ...whatAreRequirementsGetDiscountedRate },
      { ...willIKeepDiscountedRateForLifeOfLoan },
      { ...whatIfICantFindMyCreditors },
    ],
  },
  BT_REDESIGN: {
    BT_INTENT: [
      { ...howDebtPayoffLoanWork },
      { ...whatTypeOfDebtsQualify },
      { ...doINeedToPayMyDebtInFull },
      { ...whatAreTheRequirementsToGetDiscountedRate },
      { ...willIKeepDiscountedRateForLifeOfTheLoan },
      { ...whenWillLendingClubProcessThePayments },
      { ...howWillITrackThePayments },
      { ...willLendingClubCloseMyAccounts },
      { ...whenWillIGetTheRemainingFunds },
    ],
    BT_INTENT_DISPARITY: [
      { ...howDebtPayoffLoanWork },
      { ...whatTypeOfDebtsQualify },
      { ...doINeedToPayMyDebtInFull },
      { ...whenWillLendingClubProcessThePayments },
      { ...howWillITrackThePayments },
      { ...willLendingClubCloseMyAccounts },
      { ...whenWillIGetTheRemainingFunds },
    ],
    SUMMARY_PAGE: [
      { ...whenWillLendingClubProcessThePayments },
      { ...howWillITrackThePayments },
      { ...whenWillIGetTheRemainingFunds },
      { ...whatTypeOfDebtsQualify },
      { ...doINeedToPayMyDebtInFull },
      { ...willLendingClubCloseMyAccounts },
      { ...howDebtPayoffLoanWork },
      { ...whatAreTheRequirementsToGetDiscountedRate },
      { ...willIKeepDiscountedRateForLifeOfTheLoan },
    ],
    BT_WORKSHEET: [
      { ...whyTheCreditorNameLooksDifferent },
      { ...whenWillLendingClubProcessThePayments },
      { ...howWillITrackThePayments },
      { ...whenWillIGetTheRemainingFunds },
      { ...whatTypeOfDebtsQualify },
      { ...doINeedToPayMyDebtInFull },
      { ...willLendingClubCloseMyAccounts },
      { ...howDebtPayoffLoanWork },
      { ...whatAreTheRequirementsToGetDiscountedRate },
      { ...willIKeepDiscountedRateForLifeOfTheLoan },
    ],
    DIRECT_PAY: [
      { ...howDoesDirectPayWork },
      { ...whatAreTheRequirementsToGetTheDirectPayDiscount },
      { ...whatTypeOfDebtsQualifyWithDirectPay },
      { ...whyDoesTheCreditorNameLookDifferent },
      { ...whatIfICantFindMyCreditorForDirectPay },
      { ...doINeedToPayMyDebtInFullForDirectPay },
      { ...whenWillLendingClubProcessThePaymentsToMyCreditors },
      { ...howWillITrackThePaymentsToMyCreditors },
      { ...willLendingClubCloseMyAccountsWithMyCreditors },
      { ...whenWillIGetTheRemainingFundsIntoMyBankAccount },
      { ...willIKeepTheDirectPayDiscountForTheLifeOfTheLoan },
    ],
  },
  PARTNER: {
    EASY_APPLY: [
      whatIsAPersonalLoan,
      howCanIUseAPersonalLoan,
      howMuchCanIBorrow,
      willCheckingMyRateAffectMyScore,
      howQuicklyCanIGetMyLoan,
      whatHappensAfterICheckEA_Entry,
    ],
  },
};

export const FAQ_ANSWER_FLORIDA_TAX_VARIANT = [
  {
    header: 'When will I get the remaining funds deposited into my bank account?',
    details: (
      <div>
        <p>
          If approved, your loan will be issued, and we’ll subtract your origination fee, your Florida stamp tax, and
          any money used to pay your creditors. The leftover cash will be deposited into your bank account generally
          within 1 to 3 days.
        </p>
      </div>
    ),
  },
];

export const DISCLAIMERS = {
  ILOC: 'iloc',
  LBB: 'lbb',
  TOPUP: {
    LANDING: 'TopUpLanding',
    PA_LANDING: 'PATopUpLanding',
    PLUS_LANDING: 'TopUpPlusLanding',
    EXAMPLE: 'TopUpExample',
    EXAMPLE_PLUS: 'TopUpPlusExample',
    OFFER: 'TopUpOffer',
    PA_OFFER: 'PATopUpOffer',
    MB_LANDING: 'TopUpMBLanding',
    FL_TOPUP_OFFER: 'FL_TOPUP_OFFER',
    FL_OFFER: 'FL_OFFER',
  },
  TOPUPPLUS: {
    OFFER: 'TopUpPlusOffer',
    FL_OFFER: 'FL_TOPUP_PLUS_OFFER',
  },
  DEFAULT: {
    OFFER: 'DEFAULT_OFFER',
    FL_OFFER: 'FL_OFFER',
    FL_BT_INTENT: 'FL_BT_INTENT',
    BT_INTENT: 'BT_INTENT',
  },
  PARTNER: {
    EA_ENTRY: 'EA_ENTRY',
  },
  DIRECT_PAY: {
    OFFERS: 'OFFERS_DP',
    BT_MODAL: 'BT_MODAL',
    ONT_MODAL: 'ONT_MODAL',
  },
};

export const LANDING_PAGE_DISCLOSURE = {
  key: 'disclosure5',
  text: 'For TopUp Personal Loans, APR ranges from 10.49% to 35.99% and origination fee ranges from 0.00% to 8.00% on the total loan amount. APRs and origination fees are determined at the time of the application. Lowest APR is available to borrowers with excellent credit. Advertised rates and fees are valid as of January 1, 2025 and are subject to change without notice.',
};

export const OFFER_PAGE_EXTRA_DISCLOSURE = {
  key: 'disclosure1',
  text: 'A hard credit inquiry, which may affect your credit score, will only appear on your credit report if and when a loan is issued to you.',
};

export const OFFER_PAGE_DISCLOSURE = {
  key: 'disclosure2',
  text: 'All offers and terms are subject to application approval and completion of the loan issuance process. You may cancel your application at any time prior to issuance at absolutely no cost to you. There is no down payment, and you may repay your loan at any time with no additional costs or pre-payment penalties. An approved loan may issue for less than the fully requested amount, and loan closing is contingent on your acceptance of all applicable agreements and disclosures.',
};

export const TOPUP_DISCLOSURE =
  'Between January 1, 2025 to March 3, 2025, 56% of Personal Loans issued by LendingClub Bank during the same period were funded in as little as 24 hours after loan approval. The time it takes for a loan to be funded is not guaranteed and individual results vary based on multiple factors, including but not limited to investor demand.';

export const TOPUP_DISCLOSURE_0 = {
  key: 'topup-disclosure0',
  text: TOPUP_DISCLOSURE,
};

export const TOPUP_DISCLOSURE_1 = {
  key: 'topUp-disclosure1',
  text: 'Checking a rate through us generates a soft credit inquiry on a person’s credit report, which is visible only to that person. A hard credit inquiry, which is visible to that person and others, and which may affect that person’s credit score, only appears on the person’s credit report if and when a loan is issued to the person.',
};

export const TOPUP_DISCLOSURE_2 = {
  key: 'topUp-disclosure2',
  text: 'Credit eligibility is not guaranteed. APR and other credit terms depend upon credit score and other key financing characteristics, including but not limited to the amount financed, loan term length, and credit usage and history.',
};

export const TOPUP_DISCLOSURE_3 = {
  key: 'topUp-disclosure3',
  text: 'Your TopUp loan interest rate could be the same or lower than your current LendingClub personal loan. The annual percentage rate may differ based on the origination fee charged on your TopUp loan.',
};

export const TOPUP_DISCLOSURE_5 = {
  key: 'topUp-disclosure5',
  text: 'Reducing debt and maintaining low credit balances may contribute to an improvement in credit score, but results are not guaranteed. Individual results vary based on multiple factors, including but not limited to payment history and credit utilization',
};

export const TOPUP_DISCLOSURE_6 = {
  key: 'topUp-disclosure6',
  text: (
    <>
      Reducing debt and maintaining low credit balances may contribute to an improvement in credit score, but results
      are not guaranteed. Individual results vary based on multiple factors, including but not limited to payment
      history and credit utilization.
    </>
  ),
};

export const PARTNER_DISCLOSURE_EA_ENTRY_1 = {
  key: 'partner-easy-apply-ea-entry1',
  text: 'Between October 1, 2024 to December 31, 2024, Personal Loans issued by LendingClub Bank were funded within 22 hours after loan approval, on average. 57% of Personal Loans issued by LendingClub Bank during the same period were funded within 24 hours after loan approval. Loan approval, and the time it takes to issue a credit decision, are not guaranteed and individual results vary based on creditworthiness and other factors, including but not limited to investor demand.',
};

export const PARTNER_DISCLOSURE_EA_ENTRY_2 = {
  key: 'partner-easy-apply-ea-entry2',
  text: 'Any reviews presented are individual experiences and results may vary.',
};

export const TOPUP_DISCLOSURE_7 = {
  key: 'topUp-disclosure7',
  text: (
    <>
      * We use the words "pre-approved," "pre-approval," and other related words to describe a high likelihood of
      approval based on our evaluation of a person's credit profile, which we perform in advance of providing an offer
      and receiving a request for credit. These descriptions do not mean that your approval is guaranteed. Approval and
      credit eligibility are not guaranteed. This pre-approved offer does not incorporate or apply to specific loan
      amounts, APRs, or other loan terms. You received this pre-approved offer based on certain creditworthiness
      criteria and the income that we have on file for you. If your credit profile or income has changed, your request
      for credit may be declined. We may decide not to extend credit to you if you fail to provide relevant information.
      Loans are not available to consumers with pending bankruptcy proceedings. This offer may be accepted only by the
      person identified in this offer. This offer is not valid with respect to any application that includes another
      person as a co-applicant. Duplicate offers received as a result of multiple communications to the same person are
      void, as are multiple acceptances of the same offer.
    </>
  ),
};

export const TOPUP_DISCLOSURE_8 = {
  key: 'topUp-disclosure8',
  text: (
    <>
      Checking a rate through us generates a soft credit inquiry on a person’s credit report, which is visible only to
      that person. A hard credit inquiry, which is visible to that person and others, and which may affect that person’s
      credit score, only appears on the person’s credit report if and when a loan is issued to the person.
    </>
  ),
};

export const TOPUP_DISCLOSURE_11 = {
  key: 'topUp-disclosure11',
  text: (
    <>
      Reducing debt and maintaining low credit balances may contribute to an improvement in credit score, but results
      are not guaranteed. Individual results vary based on multiple factors, including but not limited to payment
      history and credit utilization.
    </>
  ),
};

export const TOPUP_EXAMPLE_DISCLOSURE_2 = {
  key: 'topUp-exampleDisclosure2',
  text: 'A minimum cash amount to your TopUp loan is required as shown at the time of making your credit request. The additional cash amount you receive is an estimate and subject to final adjustments upon approval.',
};

export const TOPUP_EXAMPLE_DISCLOSURE_4 = {
  key: 'topUp-exampleDisclosure4',
  text: 'A minimum cash out amount to your TopUp loan is required as shown at the time of making your credit request.',
};

export const TOPUP_EXAMPLE_DISCLOSURE_5 = {
  key: 'exampleDisclosure5',
  text: 'A minimum loan amount applies.',
};

export const ILOC_DISCLOSURE_1 = {
  key: 'iloc-disclosure1',
  text: '*Checking a rate through us generates a soft credit inquiry on a person’s credit report, which is visible only to that person. A hard credit inquiry, which is visible to that person and others, and which may affect that person’s credit score, only appears on the person’s credit report if and when the account is opened. Credit eligibility is not guaranteed. APR and other credit terms depend upon credit score and other key financing characteristics, including but not limited to credit usage and history.',
};

export const ILOC_DISCLOSURE_2 = {
  key: 'iloc-disclosure2',
  text: 'APR stands for Annual Percentage Rate and measures the total cost of credit annually.',
};

export const ILOC_DISCLOSURE_3 = {
  key: 'iloc-disclosure3',
  text: 'For CleanSweep line of credit, APR ranges from 8.99% to 29.99%. APRs are determined at the time of application. Lowest APR is available to borrowers with excellent credit. Advertised rates are valid as of June 30, 2023 and are subject to change without notice.',
};

export const ILOC_DISCLOSURE_4 = {
  key: 'iloc-disclosure4',
  text: 'Balance transfers may only be used to satisfy eligible debt obligations, not to purchase goods or services. Each balance transfer must be at least $200. The total of all outstanding balance transfer plans may not exceed your credit limit. We may increase or decrease the credit limit at any time and for any reason permitted by law.',
};

export const OFFER_FLORIDA_TAX = {
  key: 'offer-florida-tax',
  text: 'If you or a co-borrower resides in Florida, a stamp tax is charged in the amount of 0.35% of your loan amount. The exact amount will be deducted from the amount deposited to you and shown on your Truth in Lending Disclosure(s).',
};

export const DIRECT_PAY_1 = {
  key: 'direct-pay-1',
  text: 'To get the {{apr}}% APR Direct Pay Discount you must use a minimum of {{minAmount}} from your {{loanAmount}} loan offer to pay down credit cards and personal loans in your name. You will specify how much you want to pay on each debt, and we will send those payments directly to your creditors. Direct Pay can’t be used for student loans, mortgages, business loans, or other LendingClub personal loans. To keep things secure, we only send payments to verified creditors. If your creditor isn’t supported by LendingClub, we won’t be able to pay them off. If you cannot meet the minimum required for Direct Pay, you can lower your loan amount or turn off the Direct Pay Discount to receive the loan proceeds as cash.',
};

export const DIRECT_PAY_2 = {
  key: 'direct-pay-2',
  text: 'All offers and terms are subject to application approval and completion of the loan issuance process. You may cancel your application at any time prior to issuance at absolutely no cost to you. There is no down payment, and you may repay your loan at any time with no additional costs or pre-payment penalties. An approved loan may be issued for less than the full requested amount, and loan closing is contingent on your acceptance of all applicable agreements and disclosures.',
};

export const DIRECT_PAY_3 = {
  key: 'direct-pay-3',
  text: 'Direct Pay can’t be used for student loans, mortgages, business loans, or other LendingClub personal loans. To keep things secure, we only send payments to verified creditors. If your creditor isn’t supported by LendingClub, we won’t be able to pay them off. If you cannot meet the minimum required for Direct Pay, you can lower your loan amount or turn off the Direct Pay Discount to receive the loan proceeds as cash.',
};

export const DIRECT_PAY_4 = {
  key: 'direct-pay-4',
  text: 'The "Cash Only" column shows the rates of the {{amount}} loan for {{duration}} months including the Last Chance Discount but not the Direct Pay Discount. The "Direct Pay" column shows the rates including both, the Last Chance Discount and the Direct Pay discount.',
};

export const DIRECT_PAY_5 = {
  key: 'direct-pay-5',
  text: 'Total you would pay for the life of the loan when making your payments as agreed.',
};

const offersDisclaimer = [
  addKeyedSuperscript({
    sup: ASTRIK,
    content: OFFER_PAGE_EXTRA_DISCLOSURE,
  }),
  OFFER_PAGE_DISCLOSURE,
];

export const flDisclaimer = [
  addKeyedSuperscript({
    sup: DAGGER,
    content: OFFER_FLORIDA_TAX,
  }),
];

const topupDisclosure1WithAstrik = addKeyedSuperscript({ sup: ASTRIK, content: TOPUP_DISCLOSURE_1 });

const topupDisclosure0WithOne = addKeyedSuperscript({ sup: ONE, content: TOPUP_DISCLOSURE_0 });

const topupOfferDisclaimer = [
  topupDisclosure1WithAstrik,
  TOPUP_DISCLOSURE_2,
  OFFER_PAGE_DISCLOSURE,
  LANDING_PAGE_DISCLOSURE,
  TOPUP_DISCLOSURE_6,
];

const topupPAOfferDisclaimer = [
  TOPUP_DISCLOSURE_7,
  topupDisclosure0WithOne,
  addKeyedSuperscript({ sup: TWO, content: TOPUP_DISCLOSURE_8 }),
  TOPUP_DISCLOSURE_2,
  OFFER_PAGE_DISCLOSURE,
];

const topupPlusOfferDisclaimer = [
  topupDisclosure1WithAstrik,
  TOPUP_DISCLOSURE_2,
  LANDING_PAGE_DISCLOSURE,
  OFFER_PAGE_DISCLOSURE,
  TOPUP_EXAMPLE_DISCLOSURE_4,
  topupDisclosure0WithOne,
];

export const DISCLAIMERS_DATA = {
  [DISCLAIMERS.ILOC]: [ILOC_DISCLOSURE_1, ILOC_DISCLOSURE_2, ILOC_DISCLOSURE_3, ILOC_DISCLOSURE_4],
  [DISCLAIMERS.TOPUP.LANDING]: [
    topupDisclosure1WithAstrik,
    TOPUP_DISCLOSURE_2,
    topupDisclosure0WithOne,
    LANDING_PAGE_DISCLOSURE,
    TOPUP_DISCLOSURE_5,
  ],
  [DISCLAIMERS.TOPUP.PLUS_LANDING]: [
    topupDisclosure1WithAstrik,
    TOPUP_DISCLOSURE_2,
    topupDisclosure0WithOne,
    LANDING_PAGE_DISCLOSURE,
    TOPUP_DISCLOSURE_5,
  ],
  [DISCLAIMERS.TOPUP.MB_LANDING]: [
    topupDisclosure1WithAstrik,
    TOPUP_DISCLOSURE_2,
    TOPUP_DISCLOSURE_3,
    topupDisclosure0WithOne,
    LANDING_PAGE_DISCLOSURE,
    TOPUP_DISCLOSURE_5,
  ],
  [DISCLAIMERS.TOPUPPLUS.OFFER]: [...topupPlusOfferDisclaimer],
  [DISCLAIMERS.TOPUPPLUS.FL_OFFER]: [...flDisclaimer, ...topupPlusOfferDisclaimer],
  [DISCLAIMERS.TOPUP.PA_LANDING]: [
    TOPUP_DISCLOSURE_7,
    addKeyedSuperscript({ sup: ONE, content: TOPUP_DISCLOSURE_8 }),
    TOPUP_DISCLOSURE_2,
    addKeyedSuperscript({ sup: TWO, content: TOPUP_DISCLOSURE_3 }),
    addKeyedSuperscript({ sup: THREE, content: TOPUP_DISCLOSURE_0 }),
    LANDING_PAGE_DISCLOSURE,
    TOPUP_DISCLOSURE_11,
  ],
  [DISCLAIMERS.TOPUP.OFFER]: [...topupOfferDisclaimer],
  [DISCLAIMERS.TOPUP.FL_TOPUP_OFFER]: [...flDisclaimer, ...topupOfferDisclaimer],
  [DISCLAIMERS.TOPUP.PA_OFFER]: [...topupPAOfferDisclaimer],
  [DISCLAIMERS.TOPUP.FL_PA_OFFER]: [...flDisclaimer, ...topupPAOfferDisclaimer],
  [DISCLAIMERS.DEFAULT.FL_BT_INTENT]: [...flDisclaimer],
  [DISCLAIMERS.DEFAULT.BT_INTENT]: [],
  [DISCLAIMERS.DEFAULT.FL_OFFER]: [...flDisclaimer, ...offersDisclaimer],
  [DISCLAIMERS.DEFAULT.OFFER]: [...offersDisclaimer],
  [DISCLAIMERS.TOPUP.EXAMPLE]: [
    TOPUP_DISCLOSURE_2,
    TOPUP_EXAMPLE_DISCLOSURE_2,
    LANDING_PAGE_DISCLOSURE,
    TOPUP_EXAMPLE_DISCLOSURE_4,
  ],
  [DISCLAIMERS.TOPUP.EXAMPLE_PLUS]: [
    topupDisclosure1WithAstrik,
    TOPUP_DISCLOSURE_2,
    LANDING_PAGE_DISCLOSURE,
    TOPUP_EXAMPLE_DISCLOSURE_5,
    topupDisclosure0WithOne,
  ],
  [DISCLAIMERS.PARTNER.EA_ENTRY]: [
    addKeyedSuperscript({ sup: ONE, content: PARTNER_DISCLOSURE_EA_ENTRY_1 }),
    addKeyedSuperscript({ sup: TWO, content: PARTNER_DISCLOSURE_EA_ENTRY_2 }),
  ],
  [DISCLAIMERS.DIRECT_PAY.OFFERS]: [
    addKeyedSuperscript({ sup: ASTRIK, content: OFFER_PAGE_EXTRA_DISCLOSURE }),
    DIRECT_PAY_2,
  ],
  [DISCLAIMERS.DIRECT_PAY.BT_MODAL]: [
    addKeyedSuperscript({ sup: ONE, content: DIRECT_PAY_3 }),
    addKeyedSuperscript({ sup: TWO, content: DIRECT_PAY_5 }),
  ],
  [DISCLAIMERS.DIRECT_PAY.ONT_MODAL]: [
    addKeyedSuperscript({ sup: ONE, content: DIRECT_PAY_3 }),
    DIRECT_PAY_4,
    addKeyedSuperscript({ sup: THREE, content: DIRECT_PAY_5 }),
  ],
};

export const TOPUP_IDENTITY_URL = '/apply/personal/topup/identity';

export const TOPUP_OFFERS_URL = '/apply/personal/loan-offers/offers';

export const MODAL_CHECKLIST_DATA = ['Fixed APR', 'No prepayment penalties', 'Speedy, electronic delivery of funds'];

export const TOPUP_PLUS_CHECKLIST = [
  'Fixed APR',
  'No prepayment penalties',
  <>Funds in as little as 24 hrs upon approval{DISCLAIMER_SYMBOL.ONE}</>,
];

export const DEBTIQ_CHECKLIST = [
  'Fixed APR',
  'No prepayment penalties',
  <>Funds in as little as 24 hrs upon approval{DISCLAIMER_SYMBOL.THREE}</>,
];

export const TOPUP_PAYMENT_EXAMPLE_MODAL_DATA = {
  example: {
    loanPropsData: {
      currentOffer: {
        apr: 0.142,
        duration: 36,
        monthlyPayment: 604.25,
        originationFeeAmt: 371,
        amount: 5300,
        totalLoanAmount: 18000,
        dpType: 'CASH',
        maxDirectPayAmount: 6740,
        paymentDetails: {
          apr: '0.1713',
          asOfDate: '2023-07-11T22:40:40.000+0000',
          estimatedPayOffAmount15Days: 12700,
          monthlyPaymentAmount: '602.31',
          remainingTerm: '24',
          loanId: '120000',
        },
      },
    },
    text: "Members can choose from 24, 36, 48, 60 or 72 months for their new TopUp loan term. Let's assume this Member takes on new 36-months offer (which extends their total payoff period) at a 12.74% interest rate, expressed as a 14.20% APR.",
    checkListData: MODAL_CHECKLIST_DATA,
  },
  topUpPlusExample: {
    loanPropsData: {
      currentOffer: {
        apr: 0.1686,
        duration: 36,
        monthlyPayment: 702,
        originationFeeAmt: 1260,
        amount: 8000,
        totalLoanAmount: 21000,
        dpType: 'BT',
        maxDirectPayAmount: 6740,
        paymentDetails: {
          apr: '0.1626',
          asOfDate: '2023-07-11T22:40:40.000+0000',
          estimatedPayOffAmount15Days: 13000,
          monthlyPaymentAmount: '597',
          remainingTerm: '24',
          loanId: '12340000',
        },
      },
    },
    text: (
      <>
        This payment example assumes that the loan applicant qualifies for a 12.49% interest rate and a 6% origination
        fee on their total loan amount of $21,000. This equals a 16.86% APR over the selected 36-month loan term. The
        interest rate also assumes a discount of 0.25% on the total loan rate for choosing to have LendingClub pay down
        personal loan or credit card debt directly.
        <br />
        <br />
        The applicant has the option to choose from a 24-, 36-, 48-, 60- or 72-months loan term which can also impact
        their rates.
      </>
    ),
    checkListData: TOPUP_PLUS_CHECKLIST,
  },
};

export const INELIGIBILITY_CASES = [
  'EXCEED_MAX_OUTSTANDING_PRINCIPAL',
  'CHARGED_OFF_PRIOR_LOAN',
  'DELINQUENT_CURRENT_LOAN',
  'ENROLLED_IN_HARDSHIP_PLAN',
  'INSUFFICIENT_ON_TIME_PAYMENTS_ON_EXISTING_LOANS',
];

export const TOPUP_LEAD_TYPES = Object.keys(TOPUP_SOURCES);
export const TOPUP_PLUS_LEAD_TYPES = Object.keys(TOPUP_PLUS_SOURCES);

export const CHANNELS = {
  214642010: {
    name: 'Topup_EM',
  },
  214642011: {
    name: 'Topup_MC',
  },
  214642013: {
    name: 'Topup_Alchemy_Mobile',
  },
  214642014: {
    name: 'Topup_Alchemy_Mobile',
  },
};

export const OFFER_TYPE_NAMES = {
  control: {
    BT: 'Balance Transfer',
    CASH: 'Cash-Only',
  },
  variant: {
    BT: 'Debt Paydown',
    CASH: 'Cash',
  },
};

export const STANDALONE_DSC_TEXTS = {
  title: 'Will you use the funds from this loan to work with a debt settlement company?',
  header: 'Such as: National Debt Relief, Beyond Finance or Freedom Debt Relief',
};

export const VALID_HOME_STATUS_EXPENSE = ['RENT', 'MORTGAGE'];

export const validLivingStatus = ['RENT', 'MORTGAGE', 'OWN'];

export const VALID_LIVING_STATUS = { RENT: 'rent', MORTGAGE: 'mortgage', OWN: 'own' };

export const VARIANT_TYPES = {
  Control: 'Control',
  BT: 'BT',
  Cash: 'Cash',
  Reimagined: 'Reimagined',
};

export const BT_REIMAGINE_VALID_LOAN_PURPOSES = { cash_loan: VARIANT_TYPES.Cash, debt_consolidation: VARIANT_TYPES.BT };

export const CASH_LOAN_OPTIONS = [
  { value: 'major_purchase', label: 'Major purchase', active: true },
  { value: 'home_improvement', label: 'Home improvement', active: true },
  { value: 'life_event', label: 'Life event', active: true },
  { value: 'other', label: 'Other', active: true },
];

export const BT_REIMAGINE_LOAN_PURPOSE_OPTIONS = [
  { value: 'debt_consolidation', label: 'Debt Consolidation, Pay Off Credit Cards', active: true },
  ...CASH_LOAN_OPTIONS,
];

export const TOPUP_BANNER_VARIANT = {
  PA: 'PA_TOPUP',
  CONTROL: 'CONTROL',
};

export const PA_TOPUP_TITLE = "Congrats! You're pre-approved!*";

export const TOPUP_TITLE = {
  [TOPUP_BANNER_VARIANT.CONTROL]: 'Your TopUp™ Offer',
  [TOPUP_BANNER_VARIANT.PA]: PA_TOPUP_TITLE,
};

export const OFEE_TYPE = {
  STANDARD: 'standardOfee',
  ZERO: 'zeroOfee',
};

export const EXPERIMENT_NAME = {
  OPTIONAL_ORIGINATION_FEE: 'PL_OPTIONAL_ORIGINATION_FEE',
  DISCOUNT_STACKING_BT_WITH_ONT: 'PL_DISCOUNT_STACKING_BT_WITH_ONT',
  DISCOUNT_STACKING_BT_WITHOUT_ONT: 'PL_DISCOUNT_STACKING_BT_WITHOUT_ONT',
};

export default {
  BT_OFFER_UP_KEYS,
  CASH_OFFER_UP_KEYS,
  CU_DISCLAIMER,
  KEY_PREFIX,
  OFEE_TYPE,
  OFFER_TEMPLATES,
  OFFER_MODALS,
  OFFER_TOOLTIPS,
  OFFERS,
  OFFER_UP_TAGS,
  ONT_TYPES,
  OFFER_PAGE_EXTRA_DISCLOSURE,
  OFFER_PAGE_DISCLOSURE,
  LANDING_PAGE_DISCLOSURE,
  ILOC_DISCLOSURE_1,
  ILOC_DISCLOSURE_2,
  ILOC_DISCLOSURE_3,
  ILOC_DISCLOSURE_4,
  INELIGIBILITY_CASES,
  TIL,
  TOPUP_DISCLOSURE_1,
  TOPUP_DISCLOSURE_2,
};

